import { render } from "./CvCardKansai02.vue?vue&type=template&id=eb80b27e&scoped=true"
import script from "./CvCardKansai02.vue?vue&type=script&lang=js"
export * from "./CvCardKansai02.vue?vue&type=script&lang=js"

import "./CvCardKansai02.vue?vue&type=style&index=0&id=eb80b27e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb80b27e"]])

export default __exports__